import { NavLink } from "react-router-dom";
import { clearReviewCredentials } from "../lib/session";

/** Shared nav for the back-office screens. */
export function BackOfficeNav() {
  return (
    <div className="row-between" style={{ marginBottom: 20 }}>
      <nav className="filter-row">
        <NavLink to="/review" className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}>
          Review queue
        </NavLink>
        <NavLink
          to="/admin/content"
          className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}
        >
          Content
        </NavLink>
        <NavLink
          to="/admin/contributors"
          className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}
        >
          Contributors
        </NavLink>
        <NavLink
          to="/admin/payouts"
          className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}
        >
          Payouts
        </NavLink>
        <NavLink
          to="/admin/applications"
          className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}
        >
          Applications
        </NavLink>
        <NavLink
          to="/admin/invites"
          className={({ isActive }) => `chip ${isActive ? "chip-active" : ""}`}
        >
          Invites
        </NavLink>
      </nav>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={() => {
          clearReviewCredentials();
          window.location.reload();
        }}
      >
        Sign out
      </button>
    </div>
  );
}
